var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetscalerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18 16h4.85l6.79-8-6.79-8H2.18l6.791 8-6.79 8z",
    fill: "#0C8CE2"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTgwNjYgMTZINy4wMjk0MUwxMy44MTk4IDhMNy4wMjk0MSAwSDIuMTgwNjZMOC45NzEwNyA4TDIuMTgwNjYgMTZaIiBmaWxsPSIjMEM4Q0UyIi8+Cjwvc3ZnPgo=";
export { SvgNetscalerIcon as ReactComponent };